
import "app:rem";
import "app:normalize";
import renderApp from '@moneko/solid/entry';

renderApp();
